<template>
  <div class="color-palette">
    <!-- 1) v-for で各色を並べる -->
    <div
      v-for="option in options"
      :key="option.value"
      class="color-item"
      :class="{ selected: selectedColor === option.label || selected[item.colorKey] == option.label}"
      :style="{
        backgroundColor: getColor(option.label),
        color: pickTextColor(getColor(option.label)), // 背景によって文字色を白/黒出し分け
      }"
      @click="selectColor(option)"
    >
      <!-- ツールチップの表示 -->
      <span class="tooltip">{{ option.label }}</span>
      <!-- 2) 文字として色名を表示 -->
      <!-- {{ option.label }} -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ColorPalette",
  props: {
    options: {
      type: Array,
      required: true, // 親から渡される色の選択肢
    },
    selected: {
      type: Object
    },
    item: {
      type: Object
    },
    closeDropdown: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectedColor: null, // 現在選択中の色を保存
    };
  },

  watch: {
    selected: {
    handler() {
      this.selectedColor = null;
    },
    deep: true,
  }
  },
  methods: {
    /**
     * クリックで色を選択したとき、親コンポーネントに教える
     */
    selectColor(option) {
      this.selectedColor = option.label;
      // 親が欲しいデータ形式に応じて emit。ここでは option オブジェクトごと投げる
      this.$emit("colorSelected", option);
    },

    /**
     * 文字列(カラー名)をもとに CSS カラーコードを返す
     */
    getColor(label) {
      const colorMap = {
        ブラック: "#050711",
        ネイビー: "#272263",
        ブルー: "#283890",
        サックス: "#00AEF0",
        オレンジ: "#F1592B",
        Dオレンジ: "#F03F36",
        レッド: "#EE1C25",
        ピンク: "#ED008D",
        パープル: "#92288F",
        レモン: "#F6EE31",
        コルク: "#8C5E3C",
        チョコ: "#603813",
        グリーン: "#046939",
        Mグリーン: "#00A197",
        グレー: "#808285",
        ホワイト: "#FFFFFF",
        キャメル: "#FFE294",
        シルバー: "#949599",
        ゴールド: "#FCB040",

        // 特殊カラー例（必要なら残す/削る）
        イエロー: "#FFCA30",
        中白ブラック: "#050711",
        ミズイロ: "#0089D0",
        中白パープル: "#92288F",
        中白チョコ: "#603813",
        Lゴールド: "#FCB040",
        Rピンク: "#ED008D",
        Sピンク: "#F499C2",
        Lイエロー: "#EAD539",
        Lグリーン: "#8DC73F",
        Lシルバー: "#949599",
        銀糸: "#BBBDC0",
        金糸: "#FDBF68",
        エンジ: "#9D0917",
      };

      // const colorMap = {
      //   blk: "#231E1F",
      //   nvy: "#272263",
      //   blu: "#283890",
      //   sax: "#00AEF0",
      //   orn: "#F1592B",
      //   dor: "#F03F36",
      //   red: "#EE1C25",
      //   pnk: "#ED008D",
      //   ppl: "#92288F",
      //   lmn: "#F6EE31",
      //   crk: "#8C5E3C",
      //   cho: "#603813",
      //   grn: "#046939",
      //   mgn: "#00A197",
      //   gry: "#808285",
      //   wht: "#DCDEDF",
      //   cml: "#FFE294",
      //   sil: "#929697",
      //   gld: "#FCB040",

      //   // 特殊カラー例（必要なら残す/削る）
      //   ylw: "#FFCA30",
      //   wbk: "#332E30",
      //   sbu: "#0089D0",
      //   wpl: "#92288F",
      //   wch: "#603813",
      //   lgd: "#FCB040",
      //   rpk: "#ED008D",
      //   spk: "#F499C2",
      //   lyw: "#EAD539",
      //   lgn: "#8DC73F",
      //   lsl: "#949599",
      //   // sil: "#BBBDC0",
      //   // gld: "#FDBF68",
      //   enj: "#9D0917",
      // };

      // もしラベルが存在しない場合は白を返す
      return colorMap[label] || "#FFFFFF";
    },

    /**
     * 背景色を元に文字色を白/黒切り替え（見やすさ対策）
     */
    pickTextColor(bgColor) {
      // 簡易的に、明度が高そうなら文字色を黒、低そうなら白に
      // ここでは #RRGGBB の形式と仮定して計算する
      if (!bgColor.startsWith("#") || bgColor.length !== 7) {
        return "#000000"; // 想定外なら黒
      }
      // 例: "#F1592B" → R=241, G=89, B=43
      const r = parseInt(bgColor.slice(1, 3), 16);
      const g = parseInt(bgColor.slice(3, 5), 16);
      const b = parseInt(bgColor.slice(5, 7), 16);
      // 一般的な明度計算
      const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
      // 明るい背景なら文字は黒, 暗いなら白
      return brightness > 127.5 ? "#000000" : "#FFFFFF";
    },
  },
};
</script>

<style scoped>
/* .color-palette {
  justify-items: start;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  background-color: #666;
  padding: 10px;
  justify-content: start;
  grid-template-columns: repeat(auto-fit, minmax(18px, 1fr));
} */

.color-palette {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20px, auto));
  gap: 14px;
  background-color: #666;
  padding: 10px;
  justify-content: center;
  align-content: center;
  margin: 0 auto;
}


/* 色の「マス」を表す */
.color-item {
  /* width: 40px;
  height: 40px; */

  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-align: center;
  /* font-size: 10px;
  border-radius: 4px; */
  font-size: 0px;
  border-radius: 0px;
  box-sizing: border-box;
  user-select: none;
  /* transition: ホバー演出*/
  transition: transform 0.1s ease;
}
.color-item:hover {
  transform: scale(1.05);
}
.color-item.selected {
  outline: 3px solid white !important; /* アイコンを囲う枠をつける */
  outline-offset: 2px; /* 枠を少し離す */
}

/* ホバー時のツールチップ */
.color-item .tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 5px 8px;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
}

.color-item:hover .tooltip {
  opacity: 1;
}
</style>
